import { RequestService } from '../../../../common/services/RequestService';
import { GET_CUSTOMERS } from '../constants';
import { dataAdjustmentFiltersRequest } from '../../../Executorship/Order/api/orders/dataAdjustment';
import { adjustCustomersData } from './adjustCustomersData';

export const getFilterCustomers = async payload => {
  console.log('uygiufiu');
  const response = await RequestService.get(GET_CUSTOMERS, {
    params: dataAdjustmentFiltersRequest(payload),
  });
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(customer => adjustCustomersData(customer))
  );
};
